import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Link, useNavigate } from "react-router";

interface Props {
  link?: string;
}
export default function BackButton({ link }: Props) {
  const navigate = useNavigate();

  return (
    <div className="py-1">
      {link ? (
        <Link to={link} viewTransition className="px-4">
          <ArrowLeftOutlined />
        </Link>
      ) : (
        <Button onClick={() => navigate(-1)} type="link">
          <ArrowLeftOutlined />
        </Button>
      )}
    </div>
  );
}
